import RCTooltip from 'rc-tooltip';
import { jsx, ClassNames } from '@emotion/core';
import { BORDER_RADIUS, COLORS, FONT, PADDING } from '../../constants';
import { zIndexLevels } from '../../internalConstants';
var styles = {
  position: 'absolute',
  zIndex: zIndexLevels.popover,
  transition: '.2s opacity, .2s z-index',
  opacity: 1,
  visibility: 'visible',
  lineHeight: FONT.sizes.regular.lineHeight,
  fontFamily: FONT.family,
  fontSize: FONT.sizes.regular.fontSize,
  padding: 0,
  borderRadius: BORDER_RADIUS.medium,
  '&-hidden': {
    opacity: 0,
    zIndex: -1
  },
  '&-content': {
    background: COLORS.white,
    border: "1px solid " + COLORS.grays.cardBorder,
    borderRadius: 'inherit',
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.25)',
    maxWidth: '250px'
  },
  '&-inner': {
    color: COLORS.grays.darkest,
    textAlign: 'left',
    textDecoration: 'none',
    backgroundColor: COLORS.white,
    minHeight: '34px',
    borderRadius: 'inherit',
    border: 0,
    padding: PADDING.tiny,
    wordBreak: 'break-word'
  },
  '&-arrow, &-arrow-inner': {
    position: 'absolute',
    width: 0,
    height: 0,
    borderColor: 'transparent',
    borderStyle: 'solid'
  },
  '&-placement-top &-arrow, &-placement-topLeft &-arrow, &-placement-topRight &-arrow': {
    bottom: '-5px',
    marginLeft: '-6px',
    borderWidth: '6px 6px 0',
    borderTopColor: COLORS.grays.cardBorder
  },
  '&-placement-top &-arrow-inner, &-placement-topLeft &-arrow-inner, &-placement-topRight &-arrow-inner': {
    bottom: '1px',
    marginLeft: '-6px',
    borderWidth: '6px 6px 0',
    borderTopColor: COLORS.white
  },
  '&-placement-topLeft &-arrow': {
    marginLeft: '2px'
  },
  '&-placement-top &-arrow': {
    left: '50%'
  },
  '&-placement-topLeft &-tooltip-arrow': {
    left: '15%'
  },
  '&-placement-topRight &-arrow': {
    right: '1%'
  },
  '&-placement-right &-arrow, &-placement-rightTop &-arrow, &-placement-rightBottom &-arrow': {
    left: '-5px',
    marginTop: '-6px',
    borderWidth: '6px 6px 6px 0',
    borderRightColor: COLORS.grays.cardBorder
  },
  '&-placement-right &-arrow-inner, &-placement-rightTop &-arrow-inner, &-placement-rightBottom &-arrow-inner': {
    left: '1px',
    marginTop: '-6px',
    borderWidth: '6px 6px 6px 0',
    borderRightColor: COLORS.white
  },
  '&-placement-right &-arrow': {
    top: '50%'
  },
  '&-placement-rightTop &-arrow': {
    top: '1%',
    marginTop: 0
  },
  '&-placement-rightBottom &-arrow': {
    bottom: '1%'
  },
  '&-placement-left &-arrow, &-placement-leftTop &-arrow, &-placement-leftBottom &-arrow': {
    right: '-5px',
    marginTop: '-6px',
    borderWidth: '6px 0 6px 6px',
    borderLeftColor: COLORS.grays.cardBorder
  },
  '&-placement-left &-arrow-inner, &-placement-leftTop &-arrow-inner, &-placement-leftBottom &-arrow-inner': {
    right: '1px',
    marginTop: '-6px',
    borderWidth: '6px 0 6px 6px',
    borderLeftColor: COLORS.white
  },
  '&-placement-left &-arrow': {
    top: '50%'
  },
  '&-placement-leftTop &-arrow': {
    top: '1%',
    marginTop: 0
  },
  '&-placement-leftBottom &-arrow': {
    bottom: '1%'
  },
  '&-placement-bottom &-arrow, &-placement-bottomLeft &-arrow, &-placement-bottomRight &-arrow': {
    top: '-5px',
    marginLeft: '-6px',
    borderWidth: '0 6px 6px',
    borderBottomColor: COLORS.grays.cardBorder
  },
  '&-placement-bottom &-arrow-inner, &-placement-bottomLeft &-arrow-inner, &-placement-bottomRight &-arrow-inner': {
    top: '1px',
    marginLeft: '-6px',
    borderWidth: '0 6px 6px',
    borderBottomColor: COLORS.white
  },
  '&-placement-bottom &-arrow': {
    left: '50%'
  },
  '&-placement-bottomLeft &-arrow': {
    marginLeft: '2px'
  },
  '&-placement-bottomRight &-arrow': {
    right: '1%'
  }
};

function getOffset(placement) {
  switch (placement) {
    case 'left':
      return [-8, 0];

    case 'right':
      return [8, 0];

    case 'top':
    case 'topLeft':
    case 'topRight':
      return [0, -8];

    case 'bottom':
    case 'bottomLeft':
    case 'bottomRight':
      return [0, 8];

    case 'rightBottom':
      return [8, 0];

    case 'rightTop':
      return [8, 0];

    case 'leftBottom':
      return [-8, 0];

    case 'leftTop':
      return [-8, 0];

    default:
      return [0, 0];
  }
}

export var Popover = function Popover(_a) {
  var children = _a.children,
      className = _a.className,
      content = _a.content,
      _b = _a.placement,
      placement = _b === void 0 ? 'top' : _b,
      _c = _a.visible,
      visible = _c === void 0 ? false : _c;
  return jsx(ClassNames, null, function (_a) {
    var css = _a.css;
    var compiledStyles = css(styles);
    return jsx(RCTooltip, {
      align: {
        offset: getOffset(placement)
      },
      arrowContent: jsx("div", {
        className: compiledStyles + "-arrow-inner"
      }),
      overlay: content,
      overlayClassName: className,
      placement: placement,
      prefixCls: compiledStyles,
      trigger: ['hover', 'focus'],
      defaultVisible: visible
    }, children);
  });
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/Popover/index.js
// module id = 343
// module chunks = 0